module.exports = __webpack_public_path__ + "img/login_left_bg.952dc91e.png";